module.exports = __webpack_public_path__ + "img/case5.ab0a03df.jpg";